import React, { ReactNode } from 'react';
import { Button } from '@justgiving/react-tracking';

export type TwitterShareProps = {
  children: ReactNode;
  url: string;
  message: string;
  className?: string;
  trackingData?: Record<string, any>;
};

export class TwitterShare extends React.PureComponent<TwitterShareProps> {
  clickButton = () => {
    const { url, message } = this.props;
    const twitterHref = `https://twitter.com/intent/tweet?url=${url}&text=${message}`;

    window.open(twitterHref, 'newwindow', 'width=600,height=300');
  };

  render() {
    const { children, className, trackingData } = this.props;

    return (
      <Button
        className={`jg-btn jg-btn--twitter ${className}`}
        onClick={this.clickButton}
        type="button"
        trackingData={{
          action_name: 'click',
          subtype: 'share',
          event: 'click',
          event_value: 'twitter',
          ...trackingData,
        }}
      >
        {children}
      </Button>
    );
  }
}

export default TwitterShare;
